export default __webpack_public_path__ + "static/media/ten_of_cups.5cd2f346.png";